import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DivipolaI } from 'src/app/modelos/Divipola';
import { SuperI } from 'src/app/modelos/superintendecia.interface';
import { VariableI } from 'src/app/modelos/variable';
import { VarParamI } from 'src/app/modelos/VariableParametrica';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';

@Component({
  selector: 'app-variable',
  templateUrl: './variable.component.html',
  styleUrls: ['./variable.component.css']
})
export class VariableComponent implements OnInit {

  VariableParametrica : VarParamI;
  page : number;

  ListadoVaribles : VariableI[];
  Superintendencias : VariableI[];
  VariableNueva : VariableI;
  VariableEditar : VariableI;
  ListadoDivipola : DivipolaI[];

  Consecutivo : Array<number>;
  CodigoConsecutivo : number;
  NombreVariable : String;

  SuperTipoEntEdit : VariableI;

  NuevaVar : Boolean;
  EditarVar : Boolean;
  CodigoDisabled : Boolean;
  CodigoEditDisabled : Boolean;

  constructor(
    private api:ApiService,
    private router:Router,
    private appService:AppServiceService,
    private toastr: ToastrService,
    private activerouter: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    /*let VarParamId = this.activerouter.snapshot.paramMap.get('id');
    this.Consecutivo = new Array;
    this.SuperTipoEntEdit = new VariableI;

    this.NuevaVar = true;
    this.CodigoDisabled = true;
    this.VariableEditar = new VariableI;
    this.VariableNueva = new VariableI;
    this.VariableNueva.codigo = null;
    this.VariableNueva.nombre = "";
    this.VariableNueva.codsuper = "";

    this.VariableParametrica = new VarParamI;
    this.api.getVarParamById(VarParamId).subscribe(variable=>{
      //console.log(variable);
      this.VariableParametrica = variable;
      if(this.VariableParametrica.descrip == "Divipola"){
        this.api.findAllDeptosMunis().subscribe(Divi=>{
          this.ListadoDivipola = Divi;
          //console.log(Divi);
        });
      } else {
        this.api.getVariablesByIdParam(this.VariableParametrica.id).subscribe(Result=>{
          this.ListadoVaribles = Result;
        });
      }
    });*/
  }

  NuevaVariable(){
    /*this.NuevaVar = false;
    if (this.VariableParametrica.nombre == "Superintendencia" ||
      this.VariableParametrica.nombre == "Tipo Entidad" ||
      this.VariableParametrica.nombre == "Tenedor" ||
      this.VariableParametrica.nombre == "Rango Vivienda"){
        this.CodigoDisabled = false;
        if (this.VariableParametrica.nombre == "Tipo Entidad"){
          this.api.getVariablesByIdParam(1).subscribe(Result=>{
            this.Superintendencias = Result;
          });
        }
    } else {
      //debugger;
        this.CodigoDisabled = true;
        for (let i of this.ListadoVaribles){
          this.Consecutivo.push(i.codigo);
        }
        this.CodigoConsecutivo = Math.max(...this.Consecutivo);
        this.VariableNueva.codigo = this.CodigoConsecutivo + 1;
    }
    this.VariableNueva.idvarparam = this.VariableParametrica.id;*/
  }

  GuardarNuevaVarible(){
    /*this.NuevaVar = true;
    this.CodigoDisabled = true;
    //console.log(this.VariableNueva);
    if(this.VariableNueva.codigo == null){
      this.toastr.warning('Codigo requerido.', 'Advertencia!');
      this.NuevaVar = false;
      this.CodigoDisabled = false;
    } else if(this.VariableNueva.nombre == ""){
      this.toastr.warning('Nombre requerido.', 'Advertencia!');
      this.NuevaVar = false;
      this.CodigoDisabled = false;
    } else if(this.VariableParametrica.nombre == "Tipo Entidad" && this.VariableNueva.codsuper == ""){
      this.toastr.warning('Superintendencia requerido.', 'Advertencia!');
      this.NuevaVar = false;
      this.CodigoDisabled = false;
    } else {
      this.api.nuevaVariableReporte(this.VariableNueva).subscribe(Result2=>{
        if(Result2){
          this.toastr.success('Variable creada.', 'OK!');
          this.ngOnInit();
        }
      }, error=>{
        this.toastr.error('La variable no fue creada.', 'Error!');
        this.NuevaVariable();
      });
    }*/
  }

  EditarVariable(editar){
    /*this.VariableEditar = editar;
    this.EditarVar = false;
    if (this.VariableParametrica.nombre == "Superintendencia" ||
      this.VariableParametrica.nombre == "Tipo Entidad" ||
      this.VariableParametrica.nombre == "Tenedor" ||
      this.VariableParametrica.nombre == "Rango Vivienda"){
        this.CodigoEditDisabled = false;
        if (this.VariableParametrica.nombre == "Tipo Entidad"){
          this.api.getVariablesByIdParam(1).subscribe(Result3=>{
            this.Superintendencias = Result3;
          });
          this.api.getSuperByCodigo(this.VariableEditar.codsuper).subscribe(Result4=>{
            this.SuperTipoEntEdit = Result4;
          });
        }
    } else {
        this.CodigoEditDisabled = true;
    }*/
  }

  GuardarVariableEditada(){
    /*console.log(this.VariableEditar);
    this.EditarVar = true;
    this.CodigoDisabled = true;
    //console.log(this.VariableNueva);
    if(this.VariableEditar.codigo == 0 || this.VariableEditar.codigo == 0){
      this.toastr.warning('Codigo requerido.', 'Advertencia!');
      this.EditarVar = false;
      this.CodigoEditDisabled = false;
    } else if(this.VariableEditar.nombre == ""){
      this.toastr.warning('Nombre requerido.', 'Advertencia!');
      this.EditarVar = false;
      this.CodigoEditDisabled = false;
    } else if(this.VariableParametrica.nombre == "Tipo Entidad" && this.VariableEditar.codsuper == ""){
      this.toastr.warning('Superintendencia requerido.', 'Advertencia!');
      this.EditarVar = false;
      this.CodigoEditDisabled = false;
    } else {
      this.api.nuevaVariableReporte(this.VariableEditar).subscribe(Result5=>{
        if(Result5){
          this.toastr.success('Variable editada.', 'OK!');
          this.ngOnInit();
        }
      }, error=>{
        this.toastr.error('La variable no fue editada.', 'Error!');
        this.NuevaVariable();
      });
    }*/
  }
}
